import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import {Field} from "formik";
import PropTypes from 'prop-types';

const RecapthaField = (props) => {
    const {
        name
    } = props;

    return (
        <Field name={name}>
            {({field, form}) => (
                <ReCAPTCHA
                    sitekey="6LdArggfAAAAAFBWoH8Hg0jnJUCaO_LkyU4IYPnd"
                    {...field}
                    onChange={(val) => form.setFieldValue(name, val)}
                />
            )}
        </Field>
    )
}

RecapthaField.propTypes = {
    name: PropTypes.string.isRequired
}

export default RecapthaField;
